export default __webpack_public_path__ + "static/media/small-arrow-down.9be500d6.svg";